export const SELECTED_CUSTOMER_ID = "selected-customer-id";
export const DOCUSIGN_AUTH_STATE = "docusign-auth-state";
export const SLACK_AUTH_STATE = "slack-auth-state";
export const GOOGLE_AUTH_STATE = "slack-auth-state";
export const IS_ONBOARDING_CHECKLIST_HIDDEN = "is-onboarding-checklist-hidden";
export const IS_DEV_MODE = "is-dev-mode";
